/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */

export type AlertRuleV9RequestCheckMode =
  (typeof AlertRuleV9RequestCheckMode)[keyof typeof AlertRuleV9RequestCheckMode];

export const AlertRuleV9RequestCheckMode = {
  LEVEL_CHANGE_ONLY: 'LEVEL_CHANGE_ONLY',
  REPEATED_SAME_LEVEL: 'REPEATED_SAME_LEVEL',
} as const;
